package co.maytes.standupbot.dashboard.components.marketing

import androidx.compose.runtime.Composable
import co.maytes.standupbot.dashboard.components.motion.prefersReducedMotion
import co.maytes.standupbot.dashboard.styles.HomeTokens
import kotlinx.browser.window
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text
import org.w3c.dom.Element
import org.w3c.dom.HTMLElement

private const val LIVE_CLASS = "mk-tagline--live"
private const val WORD_CLASS = "mk-tw"
private const val LIT_CLASS = "mk-tw--lit"

@Composable
fun TaglineReveal(text: String) {
    P(
        attrs = {
            classes("mk-tagline")
            ref { element ->
                val stop: () -> Unit = if (prefersReducedMotion()) { {} } else startWordScrub(element)
                onDispose { stop() }
            }
        },
    ) {
        text.split(" ").forEachIndexed { index, word ->
            if (index > 0) Text(" ")
            Span(attrs = { classes(WORD_CLASS) }) { Text(word) }
        }
    }
}

private fun startWordScrub(root: Element): () -> Unit {
    val words = root.querySelectorAll(".$WORD_CLASS")
    var frame = 0
    var disposed = false

    fun paint() {
        frame = 0
        if (disposed) return
        val line = window.innerHeight * HomeTokens.TAGLINE_LIT_LINE
        for (i in 0 until words.length) {
            val word = words.item(i) as? HTMLElement ?: continue
            val lit = word.getBoundingClientRect().top < line
            if (lit) word.classList.add(LIT_CLASS) else word.classList.remove(LIT_CLASS)
        }
    }

    val onChange: (dynamic) -> Unit = {
        if (frame == 0) frame = window.requestAnimationFrame { paint() }
    }
    val options = js("({ passive: true })")
    val target = window.asDynamic()
    root.classList.add(LIVE_CLASS)
    paint()
    target.addEventListener("scroll", onChange, options)
    target.addEventListener("resize", onChange, options)
    return {
        disposed = true
        if (frame != 0) window.cancelAnimationFrame(frame)
        target.removeEventListener("scroll", onChange, options)
        target.removeEventListener("resize", onChange, options)
        root.classList.remove(LIVE_CLASS)
    }
}
